import { render, staticRenderFns } from "./Kategorie.vue?vue&type=template&id=b5748622&scoped=true&"
import script from "./Kategorie.vue?vue&type=script&lang=js&"
export * from "./Kategorie.vue?vue&type=script&lang=js&"
import style0 from "./Kategorie.vue?vue&type=style&index=0&id=b5748622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5748622",
  null
  
)

export default component.exports